import React from 'react';
import {
  Sparkles,
  FolderOpen,
  Trash2,
  Bomb,
  Users,
  RefreshCw,
  LucideIcon,
} from 'lucide-react';

interface Feature {
  icon: LucideIcon;
  title: string;
  description: string;
}

const features: Feature[] = [
  {
    icon: Sparkles,
    title: 'AI Vendor Detection',
    description:
      'Automatically identifies and groups emails by vendor using advanced AI',
  },
  {
    icon: FolderOpen,
    title: 'Smart Organization',
    description:
      'Separates actionable updates from cleared items with intelligent categorization',
  },
  {
    icon: Trash2,
    title: 'Auto-Delete',
    description:
      'Set retention periods and let the app automatically clean old emails',
  },
  {
    icon: Bomb,
    title: 'NUKE Feature',
    description:
      'One-click deletion of ALL emails from any vendor - past, present, and future',
  },
  {
    icon: Users,
    title: 'Multi-Account Support',
    description:
      'Connect multiple Gmail and Office 365 accounts in one unified inbox',
  },
  {
    icon: RefreshCw,
    title: 'Real-time Sync',
    description:
      'Automatic background sync keeps your inbox always up to date',
  },
];

interface FeatureCardProps {
  feature: Feature;
}

const FeatureCard: React.FC<FeatureCardProps> = ({ feature }) => {
  const Icon = feature.icon;

  return (
    <div className="bg-white rounded-2xl shadow-md p-6 transition-all duration-300 ease-in-out hover:shadow-lg hover:scale-105 cursor-pointer">
      <div className="flex flex-col items-start">
        <div className="w-12 h-12 bg-violet-100 rounded-full flex items-center justify-center mb-4">
          <Icon className="w-6 h-6 text-violet-600" />
        </div>
        <h3 className="text-lg font-bold text-gray-900 mb-2">{feature.title}</h3>
        <p className="text-gray-600 text-sm leading-relaxed">
          {feature.description}
        </p>
      </div>
    </div>
  );
};

const FeaturesSection: React.FC = () => {
  return (
    <section className="bg-gray-50 py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Everything You Need to Conquer Email Chaos
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Powerful features designed to give you back your time
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <FeatureCard key={index} feature={feature} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
